<template>
  <div>
    <h1>Events Listing</h1>
    <template v-if="page != 1">
      <router-link :to="{ name: 'event-list', query: { page: page - 1 } }" rel="prev">Previous Page</router-link>
    </template>
    <template v-if="page < lastPage">
      <router-link :to="{ name: 'event-list', query: { page: page + 1 } }" rel="next">Next Page</router-link>
    </template>
    <EventCard v-for="event in events" :key="event.id" :event="event" />
  </div>
</template>

<script>
import EventCard from "@/components/EventCard.vue";
import { mapState } from "vuex";

export default {
   name: 'EventList',
  components: {
    EventCard
  },
  created() {
    this.$store.dispatch("fetchEvents", {
      perPage: 3,
      page: this.page
    });
    /*EventService.getEvents()
      .then(response => {
        this.events = response.data
      })
      .catch(error => {
        console.log(error.response)
      })*/
  },
  computed: {
    ...mapState(["events"]),
    page() {
      return parseInt(this.$route.query.page || 1);
    },
    lastPage() {
      return Math.ceil(this.$store.state.eventCount / 3);
    }
  },
  updated() {
    this.incrementCount;
  },
  methods: {
    incrementCount() {
      this.$store.commit("INCREMENT_COUNT");
    }
  }
};
</script>

<style></style>
